export const ADD_BREADCRUMB = 'ADD_BREADCRUMB'
export const addBreadcrumb = (payload) => ({
  type: ADD_BREADCRUMB,
  payload,
})

export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS'
export const updateBreadcrumbs = () => ({
  type: UPDATE_BREADCRUMBS,
})

export const REPLACE_BREADCRUMB_AT_INDEX = 'REPLACE_BREADCRUMB_AT_INDEX'
export const replaceBreadcrumbAtIndex = (payload) => ({
  type: REPLACE_BREADCRUMB_AT_INDEX,
  payload,
})
